import { Button, message, Upload as UploadAntd } from "antd";
import React, { useState, useEffect } from "react";
import { UploadOutlined } from '@ant-design/icons';
import apiPath from "../constants/apiPath";

const SingleImageUpload = ({ fileType, imageType, btnName, onChange, initialValue }) => {

    const [fileList, setFileList] = useState(() => {
        if (initialValue && Array.isArray(initialValue) && initialValue.length > 0) {
            return initialValue.map(item => ({
                uid: item.uid || item.url || Math.random(),
                name: item.name || 'image',
                status: 'done',
                url: item.url,
                thumbUrl: item.url || item.thumbUrl,
                percent: 100,
            }));
        }
        return [];
    });

    useEffect(() => {
        if (initialValue && Array.isArray(initialValue) && initialValue.length > 0 && initialValue[0]?.url) {
            const newFileList = initialValue.map(item => ({
                uid: item.uid || item.url || Math.random(),
                name: item.name || 'image',
                status: 'done',
                url: item.url,
                thumbUrl: item.url || item.thumbUrl,
                percent: 100,
            }));
            setFileList(newFileList);
        } else {
            setFileList([]);
        }
    }, [initialValue]);

    const uploadImageToAPI = async (file) => {

        const formData = new FormData();

        formData.append("image", file);
        formData.append("type", imageType ?? "Other");

        const token = localStorage.getItem("token") || "";

        const response = await fetch(apiPath.baseURL + apiPath.commonImageUpload, {
            method: "POST",
            body: formData,
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        const result = await response.json();

        if (!result || !result.data || !result.data.upload) {
            throw new Error("Upload failed");
        }

        return result.data.upload;
    };

    const handleCustomRequest = async ({ file, onSuccess, onError }) => {
        try {
            const uploadingFile = {
                uid: file.uid,
                name: file.name,
                status: "uploading",
                percent: 50,
            };

            setFileList([uploadingFile]);

            const fileUrl = await uploadImageToAPI(file);

            const fileData = {
                uid: file.uid,
                name: file.name,
                status: "done",
                url: fileUrl,
                thumbUrl: fileUrl,
                percent: 100,
            };

            setFileList([fileData]);
            onSuccess(fileData);

            if (onChange) onChange([fileData]);
        } catch (err) {
            console.error(err);
            message.error("Upload failed");
            onError(err);
        }
    };

    const beforeUpload = (file) => {
        if (!fileType.includes(file.type)) {
            message.error("File format is not correct");
            return false;
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error("Image must be smaller than 5 MB!");
            return false;
        }
        return true;
    };

    const handleRemove = () => {
        setFileList([]);
        if (onChange) onChange([]);
    };

    return (
        <UploadAntd
            listType="picture"
            maxCount={1}
            beforeUpload={beforeUpload}
            customRequest={handleCustomRequest}
            onRemove={handleRemove}
            fileList={fileList}
        >
            {!fileList.length && (
                <Button icon={<UploadOutlined />}>Upload {btnName}</Button>
            )}
        </UploadAntd>
    );
};

export default SingleImageUpload;
